import graphql from "babel-plugin-relay/macro";

export const practitionersDropdown = graphql`
    fragment PractitionerFragments_PractitionerDropdown on Practitioner @relay(plural: true) {
        id
        applicableVersion {
            displayName
        }
    }`